/**
 * Card used on the AP details page for access points WITHOUT the new hardware variant
 * (isNewHardwareVariant false). Frozen copy of the original design.
 * TODO: delete once every access point is on the new hardware.
 */
import React from "react";
import { Box, Grid } from "@mui/material";
import { GridCellStack } from "@ui/components/grid";
import { Icon } from "@iconify/react";
import TemperatureDisplay from "@ui/components/temperature/TemperatureDisplay";
import { TemperatureStatusBadge, getNodeTemperatureColor, getNodeTemperatureStatus, } from "@ui/components/temperature";
import { StatusIndicator } from "@ui/components/status";
import { formatUtcToLocalDate, formatUtcToLocalTime, } from "@application/common/helpers/date-util";
import { useTranslation } from "react-i18next";
import { MobileCard } from "@ui/components/card";
import { SMenu } from "@ui/components/menu/SMenu";
import { SIconButton } from "@ui/components/buttons";
import { IconText } from "@ui/components/info/IconText";
import { between, colCenter } from "@ui/components/style/style";
import { PermissionChecker, Permission } from "@utility/permission-checker";
export const LegacyAPDetailsNodeCard = ({ row, tabValue, onAction, onLogs, onSettings, }) => {
    const { t } = useTranslation(["common"]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleMenuOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const menuItems = [
        ...(PermissionChecker.hasPermission(Permission.ACCESSPOINTS_DELETE)
            ? [
                {
                    label: tabValue === "disconnected"
                        ? t("common:actions.couple")
                        : t("common:actions.disconnect"),
                    onClick: () => onAction(row),
                    color: tabValue === "disconnected" ? "success" : "error",
                },
            ]
            : []),
        {
            label: t("common:actions.logs"),
            onClick: () => onLogs(row.nodeId),
        },
        ...(PermissionChecker.hasPermission(Permission.NODES_EDIT) && onSettings
            ? [
                {
                    label: t("common:actions.settings"),
                    onClick: () => onSettings(row.id),
                },
            ]
            : []),
    ];
    return (React.createElement(MobileCard, null,
        React.createElement(Box, { sx: Object.assign(Object.assign({}, colCenter), { gap: 1 }) },
            React.createElement(Box, { sx: { flexShrink: 0 } },
                React.createElement(TemperatureDisplay, { width: 91, temperature: row.nodeTemperature, color: getNodeTemperatureColor(row), leftIndicator: row.leftIndicator, rightIndicator: row.rightIndicator })),
            React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                React.createElement(GridCellStack, { topText: row.nodeName, bottomText: row.nodeId, topStyle: { fontWeight: 600, lineHeight: "20px" }, bottomVariant: "caption", bottomColor: "text.secondary" })),
            React.createElement(SIconButton, { size: "small", colorVariant: "inherit", showBackground: false, onClick: handleMenuOpen },
                React.createElement(Icon, { icon: "eva:more-vertical-fill", color: "#231F20" })),
            React.createElement(SMenu, { anchorEl: anchorEl, open: Boolean(anchorEl), handleClose: () => setAnchorEl(null), menuItems: menuItems })),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:calendar-linear", text: formatUtcToLocalDate(row.lastUpdate) })),
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:clock-circle-linear", text: formatUtcToLocalTime(row.lastUpdate) }))),
        React.createElement(Box, { sx: Object.assign({}, between) },
            React.createElement(StatusIndicator, { variant: row.status === "Active" ? "active" : "inactive" }),
            React.createElement(TemperatureStatusBadge, { status: row.nodeTypeCode === 1 ? "normal" : getNodeTemperatureStatus(row) }))));
};
